<template>
  <v-container
    id="user-profile"
    fluid
    tag="section"
  >
    <v-row justify="center">
      <v-col
        cols="12"
        md="8"
      >
        <base-material-card>
          <template v-slot:heading>
            <div class="display-2 font-weight-light">
              {{ $t('edit') }}{{ $t('account.password') }}
            </div>
          </template>

          <v-form>
            <v-container class="py-0">
              <v-row>

                <v-col cols="12">
                  <v-text-field
                    v-model="item.password"
                    :label="$t('account.password')"
                    :type="show1 ? 'text' : 'new-password'"
                    :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append="show1 = !show1"
                    :rules="rules.password"
                  />
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="item.password_repeat"
                    :label="$t('account.password-repeat')"
                    :type="show2 ? 'text' : 'new-password'"
                    :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append="show2 = !show2"
                    :rules="rules.password"
                  />
                </v-col>

                <v-col
                  cols="12"
                  class="text-right"
                >
                  <v-btn
                    color="success"
                    class="mr-0"
                    @click="save"
                  >
                    {{ $t("save") }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </base-material-card>
      </v-col>

    </v-row>
  </v-container>
</template>

<script>
import Vue from 'vue'
import BaseTable from "../tables/BaseTable.vue";
import { action_items } from "@/definition.js";
import { mapState, mapActions } from "vuex";
export default {
  data: vm => ({
    url: "/account/users/",
    item: {
      password: null,
      password_repeat: null
    },
    show1: false,
    show2: false,
    action_items: action_items,
    rules: {
      password: [
        value => {
          if (value && value.length < 6) {
            vm.disableSave = true;
            return vm.$i18n.t("invalid-password");
          }
          vm.disableSave = false;
          return true;
        }
      ]
    }
  }),
  mixins: [BaseTable],
  computed: {
    ...mapState(["token", "user"])
  },
  methods: {
    save() {
      if (this.item.password==this.item.password_repeat) {
        this.action = action_items.edit;
        this.item.id = this.user.id
        this.onSaveEvent(this.item)
        alert(this.$i18n.t("edit-pwd.success"));
      } else {
        alert(this.$i18n.t("edit-pwd.failure-not-equal"));
      }
    },
  }
};
</script>
